import 'reflect-metadata';

import * as humps from 'humps';
import { v4 as uuid } from 'uuid';

type TransformerMap = Record<string, (value: any) => any>;

export const TRANSFORMERS_KEY = Symbol('transformers');
export const DEFAULTS_KEY = Symbol('default');

/**
 * Base class for Yoshi API models
 */
export abstract class BaseEntity {
  uid: string;

  constructor(public json: object) {
    const transformed = this.transformValues(humps.camelizeKeys(json));
    this.assignProperties(transformed);
  }

  private transformValues(json: object) {
    const transformed = { ...json };
    const transformers: TransformerMap = Reflect.getMetadata(
      TRANSFORMERS_KEY,
      this
    );
    for (const key in transformers) {
      const value = transformed[key];
      const transformer = transformers[key];
      transformed[key] = value && transformer(value);
    }
    return transformed;
  }

  private assignProperties(transformed: any) {
    for (let key in transformed) {
      if (this.isKeyAssignable(key)) {
        this[key] = transformed[key];
      }
    }
    this.assignDefaultValues();
    this.uid = this.uid || uuid();
  }

  private isKeyAssignable(key: string) {
    // Don't overwrite methods or getters
    const descriptor = Object.getOwnPropertyDescriptor(
      Object.getPrototypeOf(this),
      key
    );
    return (
      !descriptor || (!descriptor.get && typeof descriptor.value !== 'function')
    );
  }

  private assignDefaultValues() {
    const defaultValues = Reflect.getMetadata(DEFAULTS_KEY, this);
    for (let key in defaultValues) {
      if (this[key] === undefined) {
        this[key] = defaultValues[key];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/base/base.ts